export enum CancelReasonAkaStudent {
  NOT_LONGER_IN_UNION = '1',
  NEW_INSURANCE = '2',
  MOVED = '3',
  NOT_IN_NEED = '4',
}
